function initBlogNav() {
	$('.toggle__category').on('click', function(e) {
		if ( $(this).hasClass('open') ) {
			$(this).removeClass('open');
			$('.blog__category').addClass('hidden-sm-down');
		} else {
			$(this).addClass('open');
			$('.blog__category').removeClass('hidden-sm-down');
		}
	});

	$('.lev1--has-children .toggle-children').on('click', function(e) {
		e.preventDefault();

		if ( $(this).closest('.lev1--has-children').hasClass('lev1--has-children--open') ) {
			$(this).closest('.lev1--has-children').removeClass('lev1--has-children--open');
			$(this).closest('.lev1--has-children').find('.lev2').slideUp( '200' );
		} else {
			$(this).closest('.lev1--has-children').addClass('lev1--has-children--open');
			$(this).closest('.lev1--has-children').find('.lev2').slideDown( '200' );
		}

	});

	$( '.lev1--has-children' ).each( function() {
		if ( $( this).hasClass( 'lev1--current' ) ) {
			$(this).addClass( 'lev1--has-children--open' );
			$(this).closest('.lev1--has-children').find('.lev2').slideDown( '200' );
		}
	});
}
